import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { Footer } from '../../footer/footer';
import { LoginDialog } from '../../../../components/web/dialogs/account/login-dialog';
import { SignUpDialog } from '../../../../components/web/dialogs/account/sign-up-dialog';
import { ForgottenPasswordDialog } from '../../../../components/web/dialogs/account/forgotten-password-dialog';
import { ResetPasswordDialog } from '../../../../components/web/dialogs/account/reset-password-dialog';
import { AlreadyLoggedInDialog } from '../../../../components/web/dialogs/account/already-logged-in-dialog';
import { Alerts } from '../../../../components/web/alerts/alerts';
import { BecomePartnerDialog } from '../../../../components/web/dialogs/become-partner/become-partner';

type LayoutBaseType = {
    children: React.ReactNode | Array<React.ReactNode>;
    footer?: React.ReactNode;
};

export const LayoutBase: React.FC<LayoutBaseType> = ({ children, footer }) => {
    const router = useRouter();
    const [email, setEmail] = useState('');

    const status = router.query.status ? router.query.status.toString() : undefined;
    const action = router.query.action ? router.query.action.toString() : undefined;
    const token = router.query.token ? router.query.token.toString() : undefined;
    const emailFromUrl = router.query.from?.toString();

    return (
        <div className="relative isolate flex min-h-screen flex-col overflow-x-clip bg-[#fdf7f2]">
            {children}
            {footer || <Footer />}

            <Alerts email={email} />

            <LoginDialog status={status} action={action} token={token} setEmail={setEmail} />
            <SignUpDialog status={status} action={action} />
            <ForgottenPasswordDialog status={status} action={action} />
            <ResetPasswordDialog status={status} action={action} />
            <AlreadyLoggedInDialog />
            <BecomePartnerDialog email={emailFromUrl} />
        </div>
    );
};
